import React, { createContext, useState } from "react";
import Axios from "../utils/Axios";
import Search, { FilterItem, SortOrder } from "../utils/Search";
import Pagination from "../utils/Pagination";

interface DocumentsInterface {
    getDocuments: (filters: FilterItem[], sortOrder: SortOrder, pageNumber?: number) => void;
    navigateDocuments: (url: string, pageNumber: number) => void;
    documents: any[];
    documentsLoading: boolean;
    documentCount: number;
    previousUrl: string;
    nextUrl: string;
    firstUrl: string;
    lastUrl: string;
    currentPage: number;
}

export const DocumentsContext = createContext<DocumentsInterface>({
    getDocuments: () => {
        throw new Error('getDocuments() method not implemented');
    },
    navigateDocuments: () => {
        throw new Error('getNextOrPrevious() method not implemented');
    },
    documents: [],
    documentsLoading: false,
    documentCount: 0,
    previousUrl: '',
    nextUrl: '',
    firstUrl: '',
    lastUrl: '',
    currentPage: 0
});

export const DocumentsProvider: React.FC = ({children}) => {

    const [documents, setDocuments] = useState([]);
    const [documentsLoading, setLoading] = useState(false);
    const [documentCount, setDocumentCount] = useState(0);
    const [previousUrl, setPreviousUrl] = useState('');
    const [nextUrl, setNextUrl] = useState('');
    const [lastUrl, setLastUrl] = useState('');
    const [firstUrl, setFirstUrl] = useState('');
    const [currentPage, setCurrentPage] = useState(1);

    const getDocuments = (filters: FilterItem[], order: SortOrder, pageNumber?: number) => {
        setLoading(true);
        const accessToken = localStorage.getItem('access_token');
        const url = `/documents${Search.getQueryString(filters, order)}`;
        if (pageNumber) setCurrentPage(pageNumber);
        Axios.get(url, {headers: {'Authorization': `Bearer ${accessToken}`} }).then((res) => {
            setDocuments(res.data.results);
            setDocumentCount(res.data.count);
            setPreviousUrl(res.data.previous);
            setNextUrl(res.data.next);
            setFirstUrl(url);
            setLastUrl(Pagination.getLastUrl(res.data.count, url));
            setLoading(false);
        }).catch(error => {
            setLoading(false);
        });
    }

    const navigateDocuments = (url: string, pageNumber: number) => {
        setLoading(true);
        const accessToken = localStorage.getItem('access_token');
        const navUrl = Pagination.getUrlAt(pageNumber, url);
        setCurrentPage(pageNumber);
        Axios.get(navUrl, {headers: {'Authorization': `Bearer ${accessToken}`} }).then((res) => {
            setDocuments(res.data.results);
            setDocumentCount(res.data.count);
            setPreviousUrl(res.data.previous);
            setNextUrl(res.data.next);
            setLoading(false);
        }).catch(error => {
            setLoading(false);
        });
    }

    return <DocumentsContext.Provider value={{
        getDocuments,
        navigateDocuments,
        documents,
        documentsLoading,
        documentCount,
        previousUrl,
        nextUrl,
        firstUrl,
        lastUrl,
        currentPage
    }}>{children}</DocumentsContext.Provider>;

}